import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=0b36ca7f&scoped=true&"
import script from "./LandingHeader.vue?vue&type=script&lang=js&"
export * from "./LandingHeader.vue?vue&type=script&lang=js&"
import style0 from "./LandingHeader.vue?vue&type=style&index=0&id=0b36ca7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b36ca7f",
  null
  
)

export default component.exports